module.exports = __webpack_public_path__ + "img/brand-pic-04.0f7eba93.png";